import { ReactElement } from 'react';
import { DataTable } from '@app/common/DataTable';
import { TableColumns, TableRows } from '@app/common/DataTable/types';
import OrderList from '../orderList';
import { OrdersTableContainer } from '../styles';

import { NullableNumber, NullableString } from '@app/common/types';
import useWindowWidth from '@app/common/useWindowWidth';

export type OrderTableI = {
  columns: TableColumns;
  rows: TableRows;
  tableRows: TableRows;
  onOrderClick: (id: NullableNumber | NullableString) => void;
};

const OrdersTable = ({
  columns,
  rows,
  tableRows,
  onOrderClick,
}: OrderTableI): ReactElement => {
  const { isMobileView } = useWindowWidth();

  return isMobileView ? (
    <OrderList onClick={onOrderClick} rows={rows} />
  ) : (
    <OrdersTableContainer>
      <DataTable onRowClick={onOrderClick} columns={columns} rows={tableRows} />
    </OrdersTableContainer>
  );
};

export default OrdersTable;
